export class Degree {
  id: string;
  title: string;

  constructor(data = {}) {
    this.id = data['id'];
    this.title = data['title'];
  }
}
